export enum ConvertType {
    GroupToSubgroup = 1,
    SubGroupToGroup
}